import React, { useEffect, useState } from 'react';
import axiosInstance from '../../lib/axios';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Button,
  Avatar,
  useTheme,
  useMediaQuery,
  IconButton,
  CircularProgress
} from '@mui/material';
import {
  Person as PersonIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  Error as ErrorIcon,
  Refresh as RefreshIcon,
  ArrowBack,
  ArrowForward
} from '@mui/icons-material';
import ProfileTab from '../../Components/ResidentDashboard/ProfileTab';
import DetailsTab from '../../Components/ResidentDashboard/DetailsTab';
// import AccountsTab from '../Components/ResidentDashboard/AccountsTab';

const ResidentDashboard = () => {
  const [bookings, setBookings] = useState([]);
  const [currentBookingIndex, setCurrentBookingIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const fetchBookingData = async () => {
      const Mobile = localStorage.getItem("Mobile");
      try {
        const response = await axiosInstance.post('TrnBooking/GetTrnBookingDashBoard', {
          start: 1,
          PageSize: 1,
          SearchText: '',
          Flag:'',
          MobileNo :Mobile,
          BookNo:'',
          PropId:1,
        });
        if (response.data.Status === 0) {
          setBookings(response.data.Data);
          if (response.data.Data.length > 0) {
            setCurrentBookingIndex(0);
          }
        } else {
          setError(response.data.Message);
        }
      } catch (err) {
        setError('Error fetching data');
      } finally {
        setLoading(false);
      }
    };

    fetchBookingData();
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleNextBooking = () => {
    setCurrentBookingIndex((prevIndex) =>
      prevIndex < bookings.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handlePrevBooking = () => {
    setCurrentBookingIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : prevIndex
    );
  };

  if (loading) return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '60vh'
    }}>
      <CircularProgress size='3rem' sx={{ width: '100%', maxWidth: 360 }} />
      <Typography variant="h6" sx={{ mt: 3 }}>
        Loading your dashboard...
      </Typography>
    </Box>
  );

  if (error) return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '60vh',
      textAlign: 'center',
      p: 3
    }}>
      <Avatar sx={{
        bgcolor: theme.palette.error.light,
        color: theme.palette.error.dark,
        width: 64,
        height: 64,
        mb: 2
      }}>
        <ErrorIcon fontSize="large" />
      </Avatar>
      <Typography variant="h5" sx={{ mb: 1 }}>
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {error}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<RefreshIcon />}
        onClick={() => window.location.reload()}
      >
        Retry
      </Button>
    </Box>
  );

  if (bookings.length === 0) return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '60vh',
      textAlign: 'center',
      p: 3
    }}>
      <Typography variant="h5" sx={{ mb: 1 }}>
        No bookings found
      </Typography>
    </Box>
  );

  const currentBooking = bookings[currentBookingIndex];

  return (
    <Box sx={{ p: isMobile ? 2 : 3 }}>
      <Box sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
      }}>
        <Typography variant="h5"
          sx={{
            fontWeight: 'bold',
            alignSelf: 'flex-start',
            display: {
              xs: 'none',
              sm: 'block',
            },
          }}
        >
          Dashboard
        </Typography>

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant={isMobile ? 'fullWidth' : 'standard'}
          sx={{
            mt: isMobile ? 2 : 0,
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <Tab
            label="Profile"
            icon={<PersonIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Details"
            icon={<ReceiptIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          {/* <Tab
            label="Accounts"
            icon={<AccountBalanceIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          /> */}
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <ProfileTab
          bookingData={currentBooking}
          onNext={handleNextBooking}
          onPrev={handlePrevBooking}
          currentIndex={currentBookingIndex}
          totalBookings={bookings.length}
        />
      )}
      {activeTab === 1 && <DetailsTab bookingData={currentBooking} />}
      {/* {activeTab === 2 && <AccountsTab bookingData={currentBooking} />} */}
    </Box>
  );
};

export default ResidentDashboard;